<template><div><h1 id="guthaben-avisierung" tabindex="-1"><a class="header-anchor" href="#guthaben-avisierung"><span>Guthaben-Avisierung</span></a></h1>
<p>Guthaben-Avisierung — Avisierung von Kunden mit offenem Guthaben</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Funktion dient dazu, um eine Liste mit offenen Guthaben zu erstellen. Die Daten können als Word-Steuerdatei exportiert werden, um Serienbriefe zu erstellen.</p>
<p>Pfad: <code v-pre>Buchhaltung → Verarbeitungsläufe → Guthaben-Avisierung</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Jobdatum</dt>
<dd>Jobdatum</dd>
<dt>Jobnummer</dt>
<dd>Jobnummer</dd>
<dt>avisieren, falls offene Fakturen vorhanden</dt>
<dd>ja/nein</dd>
<dt>Guthaben nur avisieren, wenn älter als x Tage</dt>
<dd>leer oder die Eingabe 0 bedeuted alle Guthaben werden aufgelistet</dd>
<dt>Guthaben erneut avisieren, wenn älter als x Tage</dt>
<dd>leer bedeutet alle Guthaben werden aufgelistet, 0 bedeutet bereits avisierte Guthaben werden nicht nochmals aufgelistet</dd>
<dt>Anzahl zu avisierende Guthaben</dt>
<dd>Anzahl Guthaben, die avisiert werden.</dd>
<dt>davon erneut zu avisierende</dt>
<dd>Anzahl Guthaben, die bereits schon mal avisiert wurden.</dd>
<dt>Anzahl nicht zu avisierende Guthaben</dt>
<dd>Anzahl Guthaben, die nicht avisiert werden.</dd>
<dt>davon mit offnenen Fakturen</dt>
<dd>Anzahl Guthaben mit offenen Fakturen.</dd>
<dt>Anzahl Guthaben Total</dt>
<dd>Total Anzahl Guthaben, unabhängig von den definierten Parametern.</dd>
<dt>Druckdatum</dt>
<dd>Druckdatum</dd>
<dt>Druckdatei</dt>
<dd>Druckdatei</dd>
<dt>Drucker</dt>
<dd>Drucker</dd>
<dt>Status</dt>
<dd>Status des Jobs. 1 = erfasst, 2 = läuft, 3 = abgeschlossen</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="guthaben-avis-vorbereiten" tabindex="-1"><a class="header-anchor" href="#guthaben-avis-vorbereiten"><span>Guthaben-Avis vorbereiten</span></a></h3>
<p>Die Funktion sucht alle offenen Guthaben nach den definierten Parametern.</p>
<h3 id="daten-exportieren-in-word-steuerdatei" tabindex="-1"><a class="header-anchor" href="#daten-exportieren-in-word-steuerdatei"><span>Daten exportieren in Word-Steuerdatei</span></a></h3>
<p>Exportiert die Daten in eine Word-Steuerdatei, damit danach Seriebriefe erstellt werden können.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


